export default __webpack_public_path__ + "static/media/highlyRegulated.a5f11d51.svg";